import { render, staticRenderFns } from "./EmailBounces.vue?vue&type=template&id=36b2dec5&scoped=true"
import script from "./EmailBounces.vue?vue&type=script&lang=js"
export * from "./EmailBounces.vue?vue&type=script&lang=js"
import style0 from "./EmailBounces.vue?vue&type=style&index=0&id=36b2dec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2dec5",
  null
  
)

export default component.exports